import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-update-list-slider',
  templateUrl: './update-list-slider.component.html',
  styleUrls: ['./update-list-slider.component.scss'],
})
export class UpdateListSliderComponent implements OnInit {

  @ViewChild('sliderImg') sliderImg: ElementRef<SwiperContainer>;
  @Input() imageList;

  // pasado como [passedParams] al swiper-container: así se reaplica solo cada vez que Ionic
  // reconecta la página al stack de navegación (el swiper-element se destruye en cada disconnect).
  slideOpts = {
    initialSlide: 0,
    speed: 1000,
    effect: 'slide', //slide, fade, cube, coverflow, flip
    spaceBetween: 0,
    slidesPerView: 1,
    grabCursor: true,
    slideToClickedSlide: true,
    freeMode: false
  };
  sliderIndex: number;

  constructor() { }

  ngOnInit() {
    this.sliderIndex = 0;
  }

  next() {
    this.sliderImg.nativeElement.swiper.slideNext();
  }

  prev() {
    this.sliderImg.nativeElement.swiper.slidePrev();
  }

  getCurrentItem() {
    this.sliderIndex = this.sliderImg.nativeElement.swiper.activeIndex;
  }

}
